import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { authService } from '../../services/authService';

export const AuthCallback: React.FC = () => {
  const { checkAuth } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the token from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const refreshToken = urlParams.get('refresh_token');

        if (token) {
          // Store the tokens
          authService.setToken(token);
          if (refreshToken) {
            localStorage.setItem('bri_refresh_token', refreshToken);
          }

          // Get user info to populate the cross-subdomain cookie with proper user data
          try {
            const user = await authService.getUserInfo();
            if (user) {
              // Update the cross-subdomain cookie with complete user information
              const cookieManager = authService.getCookieManager();
              cookieManager.setCrossSubdomainAuthCookie({
                jwt: token,
                sessionID: `session_${Math.random().toString(36).substr(2, 9)}_${Date.now()}`,
                userID: user.userID || 'unknown',
                audience: user.userAudience || 'BRIRC'
              });
              console.log("Set cross-subdomain cookie with user info from callback");
            }
          } catch (userInfoError) {
            console.log("Could not fetch user info for cross-subdomain cookie:", userInfoError);
            // Continue anyway - the basic cookie was already set by setToken()
          }

          // Update auth state
          await checkAuth();

          // Clear the temporary cross-subdomain cookie now that authentication is complete
          const cookieManager = authService.getCookieManager();
          cookieManager.clearCrossSubdomainAuthCookie();

          // Redirect to the main app
          window.location.href = '/';
        } else {
          // No token found, redirect to login
          window.location.href = '/';
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        window.location.href = '/';
      }
    };

    handleCallback();
  }, [checkAuth]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="background.default"
    >
      <CircularProgress size={60} color="primary" />
      <Typography variant="h6" sx={{ mt: 2 }} color="text.primary">
        Completing sign in...
      </Typography>
    </Box>
  );
};

export default AuthCallback;
